module.exports = __webpack_public_path__ + "static/media/hardik-sharma-560353-unsplash.a961e0c4.jpg";